import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-listing-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "crm-listing-error-state" */'./CrmTableErrorState').then(mod => mod.default).catch(AsyncComponentErrorHandler('crm-listing-error-state')),
  LoadingComponent: () => null
});